import { z } from "zod";
import { useCalendarToolExecutor } from "@/domains/ai/ai-chat/hooks/use-calendar-tool-executor";
import { useClientTool } from "@/domains/ai/ai-chat/hooks/use-client-tool";

/**
 * Register calendar navigation tools
 *
 * This tool allows the AI agent to navigate the calendar and change views.
 * Tools are registered in the client-tools-store and sent to the backend.
 */
export function useCalendarTools() {
  const { executeTool } = useCalendarToolExecutor();

  // Register unified updateCalendarView tool
  useClientTool({
    toolName: "updateCalendarView",
    description:
      "Update the calendar view by navigating to a specific date and/or changing the view mode. Use this when the user asks to view appointments for a particular day or switch calendar views. Both parameters are optional but at least one must be provided.",
    parameters: z.object({
      date: z
        .string()
        .optional()
        .describe(
          "Optional: The date to navigate to. Can be ISO format (YYYY-MM-DD) or relative format like 'tomorrow', 'next monday', 'today', 'next week'"
        ),
      viewMode: z
        .enum(["list", "daily", "worker", "3-day", "week", "month"])
        .optional()
        .describe("Optional: Calendar view mode to switch to"),
    }),
    execute: async (args) => {
      const result = executeTool("updateCalendarView", args);
      return result;
    },
  });
}
